import StorageService from '../interfaces';
import LocalStorageDao from '../dao/localstorage-dao';

export default {
    [StorageService.User.setInfo]({commit}, user) {
        commit(StorageService.User.setInfo, LocalStorageDao.saveUserInfo(user));
    },
    [StorageService.User.setToken]({commit}, token) {
        commit(StorageService.User.setToken, LocalStorageDao.saveUserToken(token));
    },
    [StorageService.User.saveAccount]({commit}, account) {
        commit(StorageService.User.saveAccount, LocalStorageDao.saveAccount(account));
    },
    [StorageService.Device.set]({commit}, device) {
        commit(StorageService.Device.set, LocalStorageDao.saveDevice(device));
    },
    [StorageService.TabBar.setTabBar]({commit}, tabBar) {
        commit(StorageService.TabBar.setTabBar, LocalStorageDao.saveTabBar(tabBar));
    },
    [StorageService.AlivePage.setAlivePage]({commit}, alivePage) {
        commit(StorageService.AlivePage.setAlivePage, LocalStorageDao.saveAlivePage(alivePage));
    },
    [StorageService.TabBar.setInnerTabBar]({commit}, innerTabBar) {
        commit(StorageService.TabBar.setInnerTabBar, LocalStorageDao.saveInnerTabBar(innerTabBar));
    },
    [StorageService.perm.setBtnPerm]({commit}, btnPerm) {
        commit(StorageService.perm.setBtnPerm, LocalStorageDao.saveInnerTabBar(btnPerm));
    },
    [StorageService.Reload.chnRateList]({commit}, reload) {
        commit(StorageService.Reload.chnRateList, reload);
    },
    [StorageService.Reload.tatNameList]({commit}, reload) {
        commit(StorageService.Reload.tatNameList, reload);
    },
    [StorageService.Reload.page]({commit}, reload) {
        commit(StorageService.Reload.page, reload);
    },
    [StorageService.Page.tatName]({commit}, tatSimpleNames) {
        commit(StorageService.Page.tatName, tatSimpleNames);
    },
    [StorageService.Page.currentOrgDetail]({commit}, currentOrgDetail) {
        commit(StorageService.Page.currentOrgDetail, currentOrgDetail);
    },
    [StorageService.Reload.isLoading]({commit}, flag) {
        commit(StorageService.Reload.isLoading, flag);
    },
    [StorageService.Reload.basicInfoFlag]({commit}, flag) {
        commit(StorageService.Reload.basicInfoFlag, flag);
    },

}



// WEBPACK FOOTER //
// ./src/store/service/actions.js